module.exports = __webpack_public_path__ + "media/images/umoney-68e7a4a7ea8f464ecd50dc3f20bccf1a.svg";